/* eslint-disable linebreak-style */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../app/slices/loginSlice';
import Botao from '../Botao/Botao';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { AbaContainerAcompanhamento } from './MenuAcompanhamentoEstilo';

const MenuAcompanhamento = ({
  listaOcorrenciasCompleta, listaSicCompleta, listaZeladoriasCompleta, ouvidoriaAtivo, sicAtivo, zeladoriaAtivo, onClick,
}) => {
  const dadosLogin = useSelector(selectLogin);
  const dadosCidade = useSelector(selectCidade);

  return (
    <AbaContainerAcompanhamento aba style={{ justifyContent: 'space-around' }}>
      <div>
        {((dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') || (dadosCidade && dadosCidade.configuracoes && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'S' || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'S')))
        && (
          <Botao
            aba
            label={listaOcorrenciasCompleta && listaOcorrenciasCompleta.length ? `Ouvidoria (${listaOcorrenciasCompleta.length})` : 'Ouvidoria (0)'}
            ativo={ouvidoriaAtivo}
            onClick={() => onClick('ouvidoria')}
          />
        )}
        {(((dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S'))
        || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S' && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'S' || dadosCidade.configuracoes.OcultarAnonimoSic === 'S')))
        && (
          <Botao
            aba
            label={listaSicCompleta && listaSicCompleta.length ? `Pedido de Informação (e-SIC) (${listaSicCompleta.length})` : 'Pedido de Informação (e-SIC) (0)'}
            ativo={sicAtivo}
            onClick={() => onClick('sic')}
          />
        )}
        {(((dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S'))
        || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S' && (dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'S' || dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'S')))
        && (
          <Botao
            aba
            label={listaZeladoriasCompleta && listaZeladoriasCompleta.length ? `Zeladoria (${listaZeladoriasCompleta.length})` : 'Zeladoria (0)'}
            ativo={zeladoriaAtivo}
            onClick={() => onClick('zeladoria')}
          />
        )}
      </div>
    </AbaContainerAcompanhamento>
  );
};

MenuAcompanhamento.propTypes = {
  listaOcorrenciasCompleta: PropTypes.oneOfType([PropTypes.array]),
  listaSicCompleta: PropTypes.oneOfType([PropTypes.array]),
  listaZeladoriasCompleta: PropTypes.oneOfType([PropTypes.array]),
  ouvidoriaAtivo: PropTypes.bool,
  sicAtivo: PropTypes.bool,
  zeladoriaAtivo: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

MenuAcompanhamento.defaultProps = {
  listaOcorrenciasCompleta: null,
  listaSicCompleta: null,
  listaZeladoriasCompleta: null,
  ouvidoriaAtivo: false,
  sicAtivo: false,
  zeladoriaAtivo: false,
};

export default MenuAcompanhamento;
